import {Trail} from "types/Trail";
import {dateTime, duration} from "services/date";
import deserializeTrailWaypoint from "./trail-waypoint";

/**
 * Transform the given trail by deserializing object properties
 *
 * @internal
 * @param trail
 */
export default function deserializeTrail(trail: any): Trail {
    trail.duration = duration(trail.duration);
    trail.published_at = dateTime(trail.published_at);
    trail.created_at = dateTime(trail.created_at);
    trail.updated_at = dateTime(trail.updated_at);

    trail.start_waypoint = trail.start_waypoint ? deserializeTrailWaypoint(trail.start_waypoint) : null
    trail.end_waypoint = trail.end_waypoint ? deserializeTrailWaypoint(trail.end_waypoint) : null

    trail.waypoints = trail.waypoints?.map(deserializeTrailWaypoint)

    return trail;
}